import React, { useState, useMemo } from 'react';
import { translate } from '@utils/i18n';
import { Loader, LoaderSizes } from '@components/Loader/Loader';
import { apiInternalGenericEventPath } from '@routes';
import { Button } from '@ui';
import Error from '@components/Error';
import { Modal } from '@components/v2/Modal';
import { GenericEventIcon } from '@features/Calendar/constants';
import Form from './form';
import RemoveModal from './modals/remove';
import useEditGenericEventContext from '../context/useEditGenericEventContext';
function EditGenericEventModal() {
    const namespace = 'features.modals.edit_generic_event_modal';
    const { genericEvent, modalReady, modalError, closeModal } = useEditGenericEventContext();
    const [isConfirmRemoveModalOpen, setIsConfirmRemoveModalOpen] = useState(false);
    const header = useMemo(() => {
        let icon;
        let title;
        let link = null;
        if (!genericEvent || !modalReady) {
            title = translate('loading', { namespace: 'features.commons' });
        }
        else {
            title = translate(genericEvent.eventType, { namespace });
            icon = React.createElement("i", { className: GenericEventIcon[genericEvent.eventType] });
            link = apiInternalGenericEventPath(genericEvent.id);
        }
        return (React.createElement("div", { style: { width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' } },
            React.createElement("span", { className: "dialog__faux-title" },
                icon,
                " ",
                title),
            link && (genericEvent === null || genericEvent === void 0 ? void 0 : genericEvent.canDestroy) && (React.createElement(Button, { onClick: () => {
                    setIsConfirmRemoveModalOpen(true);
                } },
                React.createElement("i", { className: "fa-light fa-trash-can" }),
                " ",
                translate('delete', { namespace: 'features.commons' })))));
    }, [genericEvent, modalReady]);
    const content = useMemo(() => {
        if (modalError)
            return React.createElement(Error, { error: modalError });
        if (modalReady)
            return React.createElement(Form, null);
        return (React.createElement("div", { style: { height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '1.6rem' } },
            React.createElement(Loader, { size: LoaderSizes.large })));
    }, [modalReady, modalError]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Modal, { onClose: closeModal, title: header, width: "480px", isOpen: true, className: "genericEventEditModal" }, content),
        React.createElement(RemoveModal, { onClose: () => {
                setIsConfirmRemoveModalOpen(false);
            }, isOpen: isConfirmRemoveModalOpen })));
}
export default EditGenericEventModal;
